import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "34667396767";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "";
// Cierre temporal de reservas online: mantener sincronizado con BOOKINGS_OPEN de backend/pricing.py
export const BOOKINGS_OPEN = false;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
